export const GQL_OPERATION_NAME = 'searchSlackChannels';

export const SLACK_CHANNELS_QUERY: string = `
query ${GQL_OPERATION_NAME}($cloudId: ID!, $limit: Int) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartySlackChannels(limit: $limit) {
        channels {
          id
          name
          isPrivate
        }
        nextCursor
      }
    }
  }
}`;

export const getSlackChannelsQuery = (): string => SLACK_CHANNELS_QUERY;
